import { Box, TextField } from "@mui/material";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState, useEffect } from "react";

export const StreamVendorsEdit = () => {
    const {
        saveButtonProps,
        refineCore: { queryResult },
        register,
        formState: { errors },
    } = useForm();
    const data = queryResult?.data?.data;
    const [config, setConfig] = useState("");
    const [pusherParams, setPusherParams] = useState("");
    const [playerParams, setPlayerParams] = useState("");
    useEffect(() => {
        if (data) {
            setConfig(JSON.stringify(data?.config));
            setPusherParams(JSON.stringify(data?.pusherParams));
            setPlayerParams(JSON.stringify(data?.playerParams));
        }
        
    },[data]);
    const testFun = (value: any, name: string) => {
        try {
            JSON.parse(value);
            return true;
          } catch (err) {
            window.alert(`The new ${name} value is not a valid json string, please check and pay attention to use double quotes!`);
            return;
          }
    }
    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <TextField
                    {...register("name", {
                    })}
                    error={!!(errors as any)?.name}
                    helperText={(errors as any)?.name?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Name"
                    name="name"
                />
                <TextField
                    {...register("showName", {
                    })}
                    error={!!(errors as any)?.showName}
                    helperText={(errors as any)?.showName?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="ShowName"
                    name="showName"
                />
                <TextField
                    {...register("config", {
                        required: "This field is required",
                        validate: () => {
                            return testFun(config, "config") === true;
                        }
                    })}
                    error={!!(errors as any)?.config}
                    helperText={(errors as any)?.config?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="config"
                    name="config"
                    multiline
                    rows={4}
                    value={config}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setConfig(event.target.value);
                    }}
                />
                <TextField
                    {...register("pusherParams", {
                        required: "This field is required",
                        validate: () => {
                            return testFun(pusherParams, "pusherParams") === true;
                        }
                    })}
                    error={!!(errors as any)?.pusherParams}
                    helperText={(errors as any)?.pusherParams?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="PusherParams"
                    name="pusherParams"
                    multiline
                    rows={4}
                    value={pusherParams}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setPusherParams(event.target.value);
                    }}
                />
                <TextField
                    {...register("playerParams", {
                        required: "This field is required",
                        validate: () => {
                            return testFun(playerParams, "playerParams") === true;
                        }
                    })}
                    error={!!(errors as any)?.playerParams}
                    helperText={(errors as any)?.playerParams?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="PlayerParams"
                    name="playerParams"
                    multiline
                    rows={4}
                    value={playerParams}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setPlayerParams(event.target.value);
                    }}
                />
            </Box>
        </Edit>
    );
};
